import { AreaCards, AreaCharts, AreaTable, AreaTop, NivoLineChart } from "../../components";

const Dashboard = () => {
   
  return (
    <div className="content-area">
      <AreaTop />
      <AreaCards />
      <AreaCharts />
      <NivoLineChart/>
     
    </div>
  );
};

export default Dashboard;
